import Api from './api';

const sendRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/request', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

export default {
    sendRequest,
}



// WEBPACK FOOTER //
// ./src/api/apiRequests.js